import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { TableService }      from '../table/table.service';
import { VehiclesComponent } from './vehicles.component';
import { VehiclesService }   from './vehicles.service';
import { VehicleModel }      from './models/vehicle';

export const VehiclesStates : Array<NgHybridStateDeclaration> = [
  {
    component: VehiclesComponent,
    name     : 'app.vehicles',
    resolve  : [
      {
        deps     : [ TableService, VehiclesService ],
        resolveFn: ( tableService : TableService, vehiclesService : VehiclesService, ) : Promise<Array<VehicleModel>> => {
          const cache = tableService.getCacheForTable(vehiclesService.tableCacheKey);

          return vehiclesService.get({
              direction: cache.sorting.direction || 'asc',
              field    : cache.sorting.field     || 'plate_number',
              offset   : 0,
              pageSize : cache.paging.pageSize   || 10
            }, {
              archivedOnly: cache.filtering.archivedOnly || false,
              value       : cache.filtering.value        || ''
            });
        },
        token: 'vehicles'
      }
    ],
    url: '/vehicles'
  }
];
